'use client';

export { default } from './SnackbarContent';
export { default as snackbarContentClasses } from './snackbarContentClasses';
export * from './snackbarContentClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SnackbarContent/index.js
// module id = 508
// module chunks = 22